import { Controller } from '@hotwired/stimulus';

// A menu that lets go: a <details>, or a [popover] (index_helper's row menu).
// It opens with no JS; this is the rest of a menu's manners: Esc shuts a
// <details> and gives the summary its focus back (a popover does that itself),
// and focus moving on (a Tab, a click elsewhere) shuts either, so an open menu
// never hangs over the stop she moved on to (WCAG 2.4.11).
//
//   <details class="dropdown" data-controller="dropdown"
//            data-action="keydown.esc->dropdown#shut focusout->dropdown#leave">
//   <ul popover data-controller="dropdown" data-action="focusout->dropdown#leave">
export default class extends Controller {
  shut() {
    this.element.open = false;
    this.element.querySelector('summary').focus();
  }

  // A popover shuts itself on a click outside, so it only minds focus that went
  // somewhere: a blur to nowhere (the window, a ring check) leaves it open.
  leave({ relatedTarget }) {
    if (this.element.contains(relatedTarget)) return;
    if (!this.element.matches('[popover]')) this.element.open = false;
    else if (relatedTarget) this.element.hidePopover();
  }
}
